import "@mdi/font/css/materialdesignicons.css"
import "@/styles/styles.sass"
import Vue from "vue"
import Vuetify from "vuetify/lib"

Vue.use(Vuetify)

const colors = {
  // 🔴 Reds
  "red-base": "#e73540",
  "red-dark": "#ef2c2c",
  "red-light": "#f5aeb3",
  "red-bg": "#fceaeb",
  // 🔵 Blues
  "blue-base": "#2172fe",
  "blue-deep": "#19418E",
  "blue-dark": "#315aff",
  "blue-accent": "#006cfa",
  "blue-alt": "#005fdc",
  "blue-soft": "#7faeed",
  "blue-light": "#b7c6ff",
  // 🟢 Greens
  "green-base": "#12bf68",
  "green-light": "#27c32c",
  // 🟡 Yellows
  "yellow-base": "#ffbb01",
  "yellow-light": "#ffeaba",
  // ⚪ Grays / Neutrals
  "gray-950": "#0f1729",
  "gray-900": "#1a1d1f",
  "gray-800": "#454c64",
  "gray-700": "#575b7d",
  "gray-650": "#65676b",
  "gray-600": "#818e94",
  "gray-500": "#9fa3b0",
  "gray-400": "#c4cdd5",
  "gray-350": "#ced0d4",
  "gray-300": "#d8d8d8",
  "gray-250": "#e3e6ef",
  "gray-240": "#e4e6eb",
  "gray-200": "#ebecee",
  "gray-150": "#eef0f5",
  "gray-125": "#f0f2f5",
  "gray-110": "#f3f3f5",
  "gray-100": "#f5f5f5",
  "gray-30": "#f8f9fb",
  "gray-25": "#f8f9fc"
}

// Vuetify colors override
const vuetifyColors = {
  primary: colors["blue-base"],
  info: colors["blue-base"],
  accent: colors["blue-accent"],
  error: colors["red-base"],
  success: colors["green-base"],
  warning: colors["yellow-base"],
  red: colors["red-base"],
  blue: colors["blue-base"],
  green: colors["green-base"],
  yellow: colors["yellow-base"]
}

export default new Vuetify({
  iconfont: "mdi",
  theme: {
    themes: {
      light: {...colors, ...vuetifyColors},
      dark: {...colors, ...vuetifyColors}
    }
  }
})
